import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'

import { ClickWrapAdditionalActionsComponent } from '../../clickwrap/types'
import * as Styled from './styled'

interface PLAgreementContentInput {
  address?: string
  company?: string
  phone?: string
  website?: string
  understandPLAgreementAcceptance: boolean
}

const PLAgreementContentActions: ClickWrapAdditionalActionsComponent<{
  className?: string
}> = React.memo(({ className, disabled = true, onChanged, readonly = false, setUserInput }) => {
  const { register, watch } = useForm<PLAgreementContentInput>()

  const { company, address, phone, website } = watch(['company', 'address', 'phone', 'website'])

  useEffect(() => {
    setUserInput({
      company: company?.trim(),
      address: address?.trim(),
      phone: phone?.trim(),
      website: website?.trim(),
    })
  }, [company, address, phone, website, onChanged, setUserInput])

  useEffect(() => {
    if (!readonly) {
      // entire form is optional
      onChanged({ isComplete: true })
    }
  }, [onChanged, readonly])

  return readonly ? null : (
    <Styled.AdditionalActionsContainer className={className}>
      <p>
        <strong>“Distributed By” Information (Optional)</strong>
        <br />
        On the label of each of your private-labeled products, we will print “Distributed By”
        contact information that you provide. You may share that information below or provide it
        later during the label design process. To update your “Distributed By” information, please
        contact{' '}
        <a href="mailto:privatelabel@designsforhealth.com" target="_blank" rel="noreferrer">
          privatelabel@designsforhealth.com
        </a>
        . You may accept the Private Label Agreement with or without providing this information now.
      </p>
      <Styled.TextInput
        label="Company Name"
        id="company"
        name="company"
        register={register}
        disabled={disabled}
        placeholder="ABC Company Inc."
        readOnly={readonly}
      />
      <Styled.TextInput
        label="Address"
        id="address"
        name="address"
        register={register}
        disabled={disabled}
        placeholder="123 Your St. Anytown, USA 01234"
        readOnly={readonly}
      />
      <Styled.TelInput
        label="Telephone"
        id="phone"
        name="phone"
        register={register}
        disabled={disabled}
        placeholder="555.867.5309"
        readOnly={readonly}
      />
      <Styled.TextInput
        label="Website"
        id="website"
        name="website"
        register={register}
        disabled={disabled}
        placeholder="www.yourwebsite.com"
        readOnly={readonly}
      />
    </Styled.AdditionalActionsContainer>
  )
})

PLAgreementContentActions.displayName = 'PLAgreementContentActions'

const StyledPLAgreementContentActions = styled(PLAgreementContentActions)``

export default StyledPLAgreementContentActions
